/** Typeahead picker over tag categories (single select). Optionally scoped to a
 *  tenant. Returns a `TagCategoryBrief` (or null) — which carries
 *  `external_identity`, because the tag forms branch on it to decide whether an
 *  External ID field belongs on the picked category. */
import * as tagCategoriesApi from '@/api/tagCategories';
import type { TagCategoryBrief } from '@/api/tags';
import { RemoteAutocomplete } from '@/components/RemoteAutocomplete/RemoteAutocomplete';

interface Props {
  value: TagCategoryBrief | null;
  onChange: (v: TagCategoryBrief | null) => void;
  /** Scope the options to one tenant's categories. */
  tourOperatorId?: number | null;
  label?: string;
  size?: 'small' | 'medium';
}

export function TagCategoryPicker({ value, onChange, tourOperatorId, label = 'Category', size = 'small' }: Props) {
  return (
    <RemoteAutocomplete<TagCategoryBrief>
      label={label}
      size={size}
      fetchOnEmpty
      value={value}
      getOptionLabel={(o) => `${o.name} (${o.code})`}
      getOptionKey={(o) => o.id}
      queryFn={async (q) =>
        (
          await tagCategoriesApi.list({
            search: q,
            pageSize: 20,
            ...(tourOperatorId != null ? { tour_operator_id: tourOperatorId } : {}),
          })
        ).results.map((c) => ({
          id: c.id,
          code: c.code,
          name: c.name,
          external_identity: c.external_identity,
        }))
      }
      onChange={(v) => onChange((v as TagCategoryBrief | null) ?? null)}
    />
  );
}
